import React from 'react';
import { Box } from '@wix/design-system';
import {
  useCurrentModule,
  ECLIPSE_PRIMARY_COLOR,
  ECLIPSE_BORDER_COLOR,
  useSelectButton,
  useProductHat,
} from '@wix/package-picker-shared-eclipse';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import { CardContent } from './CardContent';
import s from './ProductCard.scss';

interface BaseProductCardProps {
  productId: string;
}

export const BaseProductCard = ({ productId }: BaseProductCardProps) => {
  const module = useCurrentModule();
  const { ProductHat } = useProductHat({ productId });
  const { data: product } =
    module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({ productId });
  const { name, isRecommended } = product ?? {};
  const { SelectButton } = useSelectButton({ productId });

  const borderValue = isRecommended
    ? `2px solid ${ECLIPSE_PRIMARY_COLOR}`
    : `1px solid ${ECLIPSE_BORDER_COLOR}`;

  return (
    <ProductCardList.Default.Card.Root
      width="100%"
      paddingLeft="20px"
      paddingRight="20px"
      paddingBottom="40px"
      maxWidth="370px"
      minHeight="450px"
      borderRadius="16px"
      borderTop={borderValue}
      borderBottom={borderValue}
      borderLeft={borderValue}
      borderRight={borderValue}
    >
      <Box
        width="100%"
        marginTop="SP3"
        marginBottom="SP4"
        className={s.productHatWrapper}
      >
        <ProductHat />
      </Box>
      <Box
        width="100%"
        direction="vertical"
        boxSizing="border-box"
        flexGrow={1}
      >
        <CardContent
          name={name}
          isRecommended={isRecommended}
          SelectButton={SelectButton}
          productId={productId}
        />
      </Box>
    </ProductCardList.Default.Card.Root>
  );
};
